'use client'

import { Button } from '@/components/ui/button'
import homeHeroImg from '@/public/img/hero-mec.webp'
import wavyLineImg from '@/public/img/wavy-line.svg'
import { ChevronRight } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'

export default function Hero() {
  return (
    <div className="flex flex-wrap items-center justify-evenly">
      <div className="mx-auto w-full text-center lg:max-w-180 lg:text-left xl:mx-0 xl:max-w-122.25">
        <div className="mx-auto max-w-120 space-y-2 lg:mx-0">
          <h1 className="font-bold text-4.5xl text-neutral-900 leading-none md:text-5.5xl">
            Formando educadores para o Futuro
          </h1>
          <Image
            alt=""
            className="mx-auto opacity-50 lg:mx-0"
            src={wavyLineImg}
            unoptimized
            // style={'opacity': '0.5'}
            // className="ml-28 w-[12.928125rem] sm:ml-auto sm:w-86.5 md:ml-auto lg:w-86.5"
          />
        </div>
        <div className="mt-4">
          <p className="font-medium text-gray-500 text-sm md:text-lg md:leading-7">
            Comece uma nova etapa da sua Carreira com a Edooker. O seu grande
            passo começa aqui.
          </p>
          <div className="mx-auto mt-4 flex flex-col gap-3 px-6 sm:max-w-80 sm:flex-row sm:items-center sm:gap-4 sm:px-0 lg:mx-0">
            <Button
              asChild
              className="min-h-10 bg-[#308864] sm:max-w-53"
              size="lg"
            >
              <Link className="font-semibold text-sm" href="/conta/novo">
                Comece Grátis
              </Link>
            </Button>

            <Button
              asChild
              className="w-full sm:w-1/2"
              id="courses-button"
              size="lg"
            >
              <Link
                className="flex items-center justify-center gap-2 font-bold"
                href="/cursos"
              >
                Ver todos os cursos
                <ChevronRight />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-17 xl:m-0">
        <div className="w-full">
          <Image
            alt="Homem usando um notebook"
            height={546}
            placeholder="blur"
            // loading='lazy'
            priority={true}
            quality="65"
            src={homeHeroImg}
            width={588}
          />
        </div>
      </div>
    </div>
  )
}
